import { generatePath, useNavigate, useParams } from "react-router-dom";
import { TREATMENT_PLAN, TREATMENT_PLAN_REPORT_PREVIEW } from "config/paths";
import GoalsTracking from "../../components/GoalsTracking/Index";

const ClientStartSession = () => {
  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();

  const submitCallback = async (response) => {
    try {
      if (response.data) {
        navigate(
          generatePath(TREATMENT_PLAN_REPORT_PREVIEW, {
            assessmentId,
            clientId,
            clientType
          })
        );
      }
    } catch (err) {
      console.erro("Error submitting step two", err);
    }
  };

  const handleClickBack = () => {
    navigate(
      generatePath(TREATMENT_PLAN, {
        assessmentId,
        clientId,
        clientType,
      })
    );
  }

  return (
    <>
      <GoalsTracking
        onSubmit={submitCallback}
        onNavigateBack={handleClickBack}
        clientType={clientType}
      />
    </>
  );
};

export default ClientStartSession;
